import React from "react";
import KeyHandoverTicket from "../components/KeyHandoverTicket";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { Spinner } from "../../../../components/ui/spinner";
import { useTranslation } from "react-i18next";
import { useKeyHandoverStepCounter } from "../hooks/useKeyHandoverStepCounter";
import SoftSignupPrompt from "../../../account/components/SoftSignupPrompt";

function KeyHandoverBookingSummaryStep() {
	const { t } = useTranslation();
	const reservations = useSelector(
		(state: RootState) => state.bookingCreation.reservations
	);
	const location = useSelector(
		(state: RootState) => state.bookingCreation.selectedLocation
	);
	const { current, total } = useKeyHandoverStepCounter("summary");
	const isLoading = !location || !reservations || reservations.length === 0;

	if (isLoading) {
		return (
			<div className="flex h-full w-full items-center justify-center py-10">
				<Spinner size="md" />
			</div>
		);
	}

	return (
		<div className="flex flex-col justify-between h-full">
			{/* Sub headline: Step indicator under main header */}
			<p className="-mt-5 mb-6 text-xs text-muted-foreground text-center" role="status" aria-live="polite">
				{t("book_location.keys.step_counter", {
					current,
					total,
					defaultValue: "Schritt {{current}} von {{total}}",
				})}
			</p>
			<div className="overflow-auto flex-grow">
				<KeyHandoverTicket
					location={location.name}
					reservations={reservations}
				/>
				<SoftSignupPrompt />
			</div>
		</div>
	);
}

export default React.memo(KeyHandoverBookingSummaryStep);
